'use strict';

productService.$inject = ["$http", "ProductOverviewItem", "Product", "Filter", "$q", "$cacheFactory", "api", "ProductSearchRequest", "Stock", "Upload", "config", "FastOrderProduct", "ProductDiscount", "$stateParams", "MediPimData", "NewsTile", "authService"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.productService = productService;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function productService($http, ProductOverviewItem, Product, Filter, $q, $cacheFactory, api, ProductSearchRequest, Stock, Upload, config, FastOrderProduct, ProductDiscount, $stateParams, MediPimData, NewsTile, authService) {
    var cache = $cacheFactory('filterCache');

    return {
        get: get,
        getFilter: getFilter,
        getByCriteria: getByCriteria,
        getSearchResults: getSearchResults,
        searchProducts: searchProducts,
        uploadProductList: uploadProductList,
        getProductStock: getProductStock,
        getProductDiscounts: getProductDiscounts,
        calculateGrossProfit: calculateGrossProfit,
        calculateGrossProfits: calculateGrossProfits,
        calculateGrossProfitWithoutDiscount: calculateGrossProfitWithoutDiscount,
        calculateGrossProfitAmounts: calculateGrossProfitAmounts,
        calculateGrossProfitAmount: calculateGrossProfitAmount,
        calculateGrossProfitAmountWithoutDiscount: calculateGrossProfitAmountWithoutDiscount,
        calculateGrossProfitAmountWithDiscount: calculateGrossProfitAmountWithDiscount,
        formatProductDiscount: formatProductDiscount,
        getByCriteriaForOutlet: getByCriteriaForOutlet,
        getProductMedipimdata: getProductMedipimdata
    };

    function get(id) {
        var promises = [];
        promises.push(api.products.get({ id: id }).$promise);
        if (authService.isBuyer) {
            promises.push(api.shoppingCartProducts.get({}).$promise);
        } else {
            promises.push(Promise.resolve());
        }
        var params = {
            skip: 0,
            take: 3,
            productId: id
        };
        promises.push(api.newsSearch.execute(params).$promise);
        promises.push(api.productDiscounts.get({ productId: id }).$promise);

        return $q.all(promises).then(function (results) {
            var product = results[0];
            var cartProducts = results[1];
            var topNewsitems = _lodash2.default.map(results[2].results, function (i) {
                return NewsTile.create(i);
            });
            var productDiscounts = formatProductDiscount(ProductDiscount.create(results[3]));

            var prod = Product.getClass().create(product, cartProducts, null, product.productTypeCode, topNewsitems, productDiscounts);
            prod.grossProfit = calculateGrossProfit(prod);
            prod.grossProfitAmount = calculateGrossProfitAmount(prod);
            calculateGrossProfits(prod.included_products);
            calculateGrossProfitAmounts(prod.included_products);
            prod.shoppingCartProducts = cartProducts;
            return prod;
        });
    }
    function getProductMedipimdata(productId) {
        return api.productMedipim.getMedipimData({ productId: productId }).$promise.then(function (response) {
            return MediPimData.create(response);
        });
    }
    function getProductStock(model, productNumber, quantity) {
        return api.productStock.get({ productNumber: productNumber, quantity: quantity }).$promise.then(function (response) {
            model.stock = Stock.create(response);
            return model;
        });
    }

    function getProductDiscounts(productId) {
        return api.productDiscounts.get({ productId: productId }).$promise.then(function (response) {
            return ProductDiscount.create(response);
        });
    }

    function getByCriteria(searchRequest) {
        var promises = [];
        promises.push(api.productSearch.search(searchRequest).$promise);
        if (authService.isBuyer) {
            promises.push(api.shoppingCartProducts.get({}).$promise);
        } else {
            promises.push(Promise.resolve());
        }
        return $q.all(promises).then(function (results) {
            var searchResponse = results[0];
            var cartProducts = results[1];
            var productResources = searchResponse.results;

            var products = _lodash2.default.map(productResources, function (resource) {
                return ProductOverviewItem.getClass().create(resource, cartProducts, searchRequest.context);
            });
            calculateGrossProfits(products);
            calculateGrossProfitAmounts(products);
            return {
                totalItems: searchResponse.count,
                products: products,
                filters: null
            };
        });
    }
    function getByCriteriaForOutlet(searchRequest) {
        var promises = [];
        promises.push(api.outletProductsSearch.search(searchRequest).$promise);
        if (authService.isBuyer) {
            promises.push(api.shoppingCartProducts.get({}).$promise);
        }
        return $q.all(promises).then(function (results) {
            var searchResponse = results[0];
            var cartProducts = results[1];
            var productResources = searchResponse.results;

            var products = _lodash2.default.map(productResources, function (resource) {
                return ProductOverviewItem.getClass().create(resource, cartProducts, searchRequest.context);
            });
            calculateGrossProfits(products);
            calculateGrossProfitAmounts(products);
            return {
                totalItems: searchResponse.count,
                products: products,
                filters: null
            };
        });
    }
    function getFilter(params) {

        var cachedFilter = void 0;
        var cachedFilterDate = void 0;

        //do not chache te filter
        if (!params.IsDiscountView && params.CacheFilter) {
            cachedFilter = cache.get('product-filters?sellerId=' + params.SellerId + '&context=' + params.context + '&isDiscountView=' + params.IsDiscountView + '&lang=' + $stateParams.language);
            cachedFilterDate = cache.put('cachedFilterDate', (0, _moment2.default)());
        }

        if (cachedFilter) {

            // clear the filter if older than one day
            if (cachedFilterDate.diff((0, _moment2.default)().subtract(1, 'days'), 'days') > 1) {
                cachedFilter = null;
                cachedFilterDate = null;
            }

            return Filter.create(cachedFilter);
        } else {
            return api.productFilter.get(params).$promise.then(function (response) {

                if (!params.IsDiscountView && params.CacheFilter) {
                    cache.put('product-filters?sellerId=' + params.SellerId + '&context=' + params.context + '&isDiscountView=' + params.IsDiscountView + '&lang=' + $stateParams.language, response);
                    cache.put('cachedFilterDate', (0, _moment2.default)());
                }

                return Filter.create(response);
            });
        }
    }

    function getSearchResults(searchValue) {
        var searchRequest = ProductSearchRequest.createForSearch({ skip: 0, take: 3, sortAsc: true, filter: '' }, searchValue);
        return this.getByCriteria(searchRequest).then(function (resources) {
            var mappedItems = _lodash2.default.map(resources.products, function (p) {
                return {
                    id: p.id,
                    name: p.displayName,
                    image: p.image,
                    discountId: p.discountId
                };
            });

            return {
                totalItems: resources.totalItems,
                products: mappedItems
            };
        });
    }

    /* Products search home and fast order*/
    function searchProducts(searchString, take) {
        return api.searchProduct.execute({ search: searchString, take: take }).$promise.then(function (resource) {
            return _lodash2.default.map(resource, function (o) {
                return Product.getClass().create(o);
            });
        });
    }

    /* Product list upload fast order page */
    function uploadProductList(file) {
        return Upload.upload({
            url: config.webApiBaseUrl + 'shoppingcart/UploadProductList',
            data: { file: file }
        }).then(function (result) {
            return _lodash2.default.map(result.data, function (o) {
                return FastOrderProduct.create(o);
            });
        });
    }

    function calculateGrossProfits(products) {
        products.forEach(function (product) {
            product.grossProfit = calculateGrossProfit(product);
        });
    }

    function calculateGrossProfit(product) {
        var publicPrice = product.netPublicPrice || 0;
        var pharmacyPrice = product.discountPct ? (product.price !== 0 ? product.price : 0) * ((100 - product.discountPct) / 100) : product.price;
        return (publicPrice === 0 ? 0 : (publicPrice - pharmacyPrice) / publicPrice * 100).toFixed(0);
    }

    function calculateGrossProfitWithoutDiscount(product) {
        var publicPrice = product.netPublicPrice || 0;
        var pharmacyPrice = product.price || 0;
        return (publicPrice === 0 ? 0 : (publicPrice - pharmacyPrice) / publicPrice * 100).toFixed(0);
    }
    function calculateGrossProfitAmounts(products) {
        products.forEach(function (product) {
            product.grossProfitAmount = calculateGrossProfitAmount(product);
        });
    }

    function calculateGrossProfitAmountWithoutDiscount(product) {
        var publicPrice = product.netPublicPrice || 0;
        var pharmacyPrice = product.price || 0;
        var grossProfitAmount = (publicPrice === 0 ? 0 : publicPrice - pharmacyPrice) * product.quantity;
        return grossProfitAmount;
    }
    function calculateGrossProfitAmount(product) {
        return product.discountPct > 0 ? calculateGrossProfitAmountWithDiscount(product) : calculateGrossProfitAmountWithoutDiscount(product);
    }
    function calculateGrossProfitAmountWithDiscount(product) {
        var publicPrice = product.netPublicPrice || 0;
        var pharmacyPrice = product.discountPct ? (product.price !== 0 ? product.price : 0) * ((100 - product.discountPct) / 100) : product.price;
        var grossProfitAmount = (publicPrice === 0 ? 0 : publicPrice - pharmacyPrice) * product.quantity;
        return grossProfitAmount;
    }

    function formatProductDiscount(discount) {

        //if there are no product discounts return the totalPriceDiscounts, else this won't be shown
        if (discount.allProductDiscounts.length === 0) {
            return [discount.totalPriceDiscounts];
        }

        var groupedProductDiscounts = _lodash2.default.groupBy(discount.allProductDiscounts, 'sellerBaseCodeId');

        /* add totalprice discount to the correct group or create a new group when none is found */
        discount.totalPriceDiscounts.forEach(function (totalPriceDiscount) {
            if (groupedProductDiscounts[totalPriceDiscount.sellerCodeId]) {
                groupedProductDiscounts[totalPriceDiscount.sellerCodeId].push(totalPriceDiscount);
            } else {
                groupedProductDiscounts[totalPriceDiscount.sellerCodeId] = [];
                groupedProductDiscounts[totalPriceDiscount.sellerCodeId].push(totalPriceDiscount);
            }
        });

        return _lodash2.default.values(groupedProductDiscounts);
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/productService.js
// module id = 824
// module chunks = 0